import { useNavigate } from 'react-router-dom';
import ProfileGoBackButton from '../../ProfileGoBackButton/ProfileGoBackButton';
import './CollectionAdd.css';
import { ARTICL_NAME, DEFAULT_MAX_IMG_SIZE, IMG_PLACEHOLDER_PRODUCT, PROFILE_COLLECTION_MAIN_LINK, PROFILE_MAIN_LINK } from '../../../../assets/utils/constants';
import { useState } from 'react';
import mainAppApi from '../../../../assets/api/MainAppApi';
import { parseApiError, parsePrice, parseTitleForParts } from '../../../../assets/utils/utils';
import useAutoDismissError from '../../../../assets/hooks/useAutoDismissError';
import Search from '../../../Search/Search';
import moment from 'moment';
import Input from '../../../Input/Input';
import MiniPreloader from '../../../MiniPreloader/MiniPreloader';

function CollectionAdd() {
    const [values, setValues] = useState({
        image: null,
        name: '',
        purchase_date: moment().format('YYYY-MM-DD'),
        purchase_price: '',
        reference: '',

    })
    const [preloaders, setPreloaders] = useState({
        addToCollection: false,
        imgOnLoad: false,
    })

    const [valuesValidity, setValuesValidity] = useState({
        image: {}
    })

    const [imageLoadError, setImageLoadError] = useAutoDismissError()
    function handleImageChange(e) {
        const input = e.target;
        const file = input.files[0];

        if (file && file.size / 1000000 >= DEFAULT_MAX_IMG_SIZE) {
            setValuesValidity((prevValue) => ({
                ...prevValue,
                image: { ...prevValue.avatar, errorMessage: "", validState: false },
            }));
            return;
        }

        let data = new FormData();
        data.append("image", file);
        // setIsPhotoLoading(true);
        setPreloaders(prevValue => ({
            ...prevValue,
            imgOnLoad: true,
        }))
        mainAppApi
            .uploadImage({ data, type: 'images' })
            .then((res) => {
                setValues((prevValue) => ({
                    ...prevValue,
                    image: res,
                }));
                setValuesValidity((prevValue) => ({
                    ...prevValue,
                    image: { errorMessage: "", validState: true, isChanged: true },
                }));
            })
            .catch((err) => {
                setImageLoadError(parseApiError(err));
            })
            .finally(() => {
                setPreloaders(prevValue => ({
                    ...prevValue,
                    imgOnLoad: false,
                }))
            });
    }

    function selectSearchItem(item) {
        console.log(item)
        const now = moment().format('YYYY-MM-DD');
        setValues({
            name: `${item.name && item.name.length > 0 ? parseTitleForParts(item.name).title : ``}${item.name && item.name.length > 0 && parseTitleForParts(item.name).subtitle ? ` ` + parseTitleForParts(item.name).subtitle : ``}`,
            image: item.files[0],
            purchase_price: parsePrice(item.price_data.price, 'USD'),
            reference: item?.parameters?.find((item2) => item2.name === ARTICL_NAME) ? item?.parameters?.find((item2) => item2.name === ARTICL_NAME).value : '',
            purchase_date: now,
        })
    }

    const navigate = useNavigate()

    function handleChange(e) {
        const input = e.target;
        const name = input.name;
        let value = input.value;
        switch (name) {
            case 'purchase_price': {
                let inputValue = value.replace(/\D/g, '');
                let formattedInputValue = '';
                if (!inputValue) {
                    setValues((prevValue) => ({
                        ...prevValue,
                        [name]: '',
                    }));
                } else {
                    formattedInputValue = parsePrice(inputValue.substring(0, 16), 'USD');
                    setValues((prevValue) => ({
                        ...prevValue,
                        [name]: formattedInputValue,
                    }));
                }
                break;
            }


            default: {
                setValues((prevValue) => ({
                    ...prevValue,
                    [name]: value,
                }));
                break;
            }
        }

    }


    const [addToCollectionError, setAddToCollectionError] = useAutoDismissError()


    function handleAddToCollection() {
        setPreloaders(prevValue => ({
            ...prevValue,
            addToCollection: true,
        }))
        mainAppApi.collectionCreateItem({
            name: values.name,
            reference: values.reference,
            image: values.image ? values.image._id : null,
            purchase_price: values.purchase_price.replace(/\D/g, ''),
            purchase_date: moment(values.purchase_date).format('YYYY-MM-DD'),
        })
            .then((res) => {
                console.log(res)
                navigate(`/${PROFILE_MAIN_LINK}/${PROFILE_COLLECTION_MAIN_LINK}`)
            })
            .catch((err) => {
                console.log(err)
                setAddToCollectionError(parseApiError(err))
            })
            .finally(() => {
                setPreloaders(prevValue => ({
                    ...prevValue,
                    addToCollection: false,
                }))
            })
    }
    return (
        <div className='collection-add'>
            <div className='collection-add__heading'>
                <ProfileGoBackButton
                    onClick={() => {
                        navigate(`/${PROFILE_MAIN_LINK}/${PROFILE_COLLECTION_MAIN_LINK}`)
                    }}
                />
                <div className='collection-add__heading-title-box' >
                    <p className='collection-add__heading-title'>Add Item</p>
                </div>
            </div>
            <label
                className="collection-add__avatar"
                htmlFor={'collection-add__avatar-input'}
            >
                <input onChange={handleImageChange} type="file" className="collection-add__avatar-input" id='collection-add__avatar-input' accept='image/png, image/jpeg'></input>
                {preloaders.imgOnLoad ?
                    <div className='collection-add__avatar-input-loader'>
                        <MiniPreloader  />
                    </div>
                    : null}
                {values.image ? <img key={values.image.urls.orig} className='collection-add__avatar-img' src={values.image.urls.orig} alt='' /> : <img className='collection-add__avatar-img' src={IMG_PLACEHOLDER_PRODUCT} alt='' />}
                <div className='collection-add__avatar-icon'>
                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.66634 3V3.6C4.86695 3.6 5.05429 3.49974 5.16557 3.33282L4.66634 3ZM5.60385 1.59373L5.10462 1.26091L5.10462 1.26091L5.60385 1.59373ZM10.3955 1.59373L10.8947 1.26091L10.8947 1.26091L10.3955 1.59373ZM11.333 3L10.8338 3.33282C10.9451 3.49974 11.1324 3.6 11.333 3.6V3ZM9.99967 8H9.39967C9.39967 8.7732 8.77287 9.4 7.99967 9.4V10V10.6C9.43561 10.6 10.5997 9.43594 10.5997 8H9.99967ZM7.99967 10V9.4C7.22648 9.4 6.59967 8.7732 6.59967 8H5.99967H5.39967C5.39967 9.43594 6.56373 10.6 7.99967 10.6V10ZM5.99967 8H6.59967C6.59967 7.2268 7.22648 6.6 7.99967 6.6V6V5.4C6.56373 5.4 5.39967 6.56406 5.39967 8H5.99967ZM7.99967 6V6.6C8.77287 6.6 9.39967 7.2268 9.39967 8H9.99967H10.5997C10.5997 6.56406 9.43561 5.4 7.99967 5.4V6ZM4.66634 3L5.16557 3.33282L6.10308 1.92655L5.60385 1.59373L5.10462 1.26091L4.16711 2.66718L4.66634 3ZM6.71325 1V1.6H9.2861V1V0.4H6.71325V1ZM10.3955 1.59373L9.89627 1.92655L10.8338 3.33282L11.333 3L11.8322 2.66718L10.8947 1.26091L10.3955 1.59373ZM9.2861 1V1.6C9.53129 1.6 9.76026 1.72254 9.89627 1.92655L10.3955 1.59373L10.8947 1.26091C10.5362 0.723062 9.93251 0.4 9.2861 0.4V1ZM5.60385 1.59373L6.10308 1.92655C6.23909 1.72254 6.46806 1.6 6.71325 1.6V1V0.4C6.06684 0.4 5.46319 0.723062 5.10462 1.26091L5.60385 1.59373ZM14.6663 5.66667H14.0663V10.3333H14.6663H15.2663V5.66667H14.6663ZM11.9997 13V12.4H3.99967V13V13.6H11.9997V13ZM1.33301 10.3333H1.93301V5.66667H1.33301H0.733008V10.3333H1.33301ZM3.99967 13V12.4C2.85829 12.4 1.93301 11.4747 1.93301 10.3333H1.33301H0.733008C0.733008 12.1375 2.19554 13.6 3.99967 13.6V13ZM14.6663 10.3333H14.0663C14.0663 11.4747 13.1411 12.4 11.9997 12.4V13V13.6C13.8038 13.6 15.2663 12.1375 15.2663 10.3333H14.6663ZM11.9997 3V3.6C13.1411 3.6 14.0663 4.52528 14.0663 5.66667H14.6663H15.2663C15.2663 3.86254 13.8038 2.4 11.9997 2.4V3ZM3.99967 3V2.4C2.19554 2.4 0.733008 3.86254 0.733008 5.66667H1.33301H1.93301C1.93301 4.52528 2.85829 3.6 3.99967 3.6V3ZM3.99967 3V3.6H4.66634V3V2.4H3.99967V3ZM11.9997 3V2.4H11.333V3V3.6H11.9997V3Z" fill="white" />
                    </svg>

                </div>
            </label>
            <Search selectSearchItem={selectSearchItem} placeholder={'Find by Reference or Name'} className={'collection-add__search'} type={'select'} />
            <div className='collection-add__separator'>
                <p className='collection-add__separator-text'>Or Add Custom</p>
            </div>
            <div className='collection-add__inputs'>
                <div className='collection-add__input-item'>
                    <p className='collection-add__input-title'>Item Name</p>
                    <div className='collection-add__input-box'>
                        <Input
                            value={values.name}
                            handleChange={handleChange}
                            name={"name"}
                            placeholder={'Enter Item Name'}
                        />
                    </div>
                </div>
                <div className='collection-add__input-item'>
                    <p className='collection-add__input-title'>Reference ID</p>
                    <div className='collection-add__input-box'>
                        <Input
                            value={values.reference}
                            handleChange={handleChange}
                            name={"reference"}
                            placeholder={'Enter Reference ID'}
                        />
                    </div>
                </div>
                <div className='collection-add__input-item'>
                    <p className='collection-add__input-title'>Purchase Price</p>
                    <div className='collection-add__input-box'>
                        <Input
                            value={values.purchase_price}
                            handleChange={handleChange}
                            name={"purchase_price"}
                            placeholder={'Enter Purchase Price'}
                        />
                    </div>
                </div>
                <div className='collection-add__input-item'>
                    <p className='collection-add__input-title'>Purchase Date</p>
                    <div className='collection-add__input-box'>
                        <Input
                            value={values.purchase_date}
                            handleChange={handleChange}
                            name={"purchase_date"}
                            placeholder={'Enter Purchase Date'}
                            type={'date'}
                        />
                    </div>
                </div>
            </div>
            <button className={`collection-add__submit ${!(values.name && values.reference && values.purchase_date && values.purchase_price && Number(values.purchase_price.replace(/\D/g, '')) > 0) || preloaders.addToCollection ? 'collection-add__submit_inactive' : ''}`} type='button' onClick={handleAddToCollection}>
                {preloaders.addToCollection ? <MiniPreloader isLinkColor={true} /> : 'Add to Collection'}
            </button>
            {addToCollectionError ?
                <p className='collection-add__submit-error'>{addToCollectionError}</p>
                : null}
        </div>
    );
}

export default CollectionAdd